'use client'
import {
  Button_default
} from "./chunk-EGOGHW2A.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/Collapsible/Collapsible.tsx
import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";
import { twMerge } from "tailwind-merge";
import { jsx, jsxs } from "react/jsx-runtime";
var Collapsible = (_a) => {
  var _b = _a, { trigger, children, contentClassName } = _b, props = __objRest(_b, ["trigger", "children", "contentClassName"]);
  return /* @__PURE__ */ jsxs(CollapsiblePrimitive.Root, __spreadProps(__spreadValues({}, props), { children: [
    /* @__PURE__ */ jsx(CollapsiblePrimitive.Trigger, { asChild: true, children: trigger }),
    /* @__PURE__ */ jsx(
      CollapsiblePrimitive.Content,
      {
        className: twMerge(
          "data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down overflow-hidden transition-all",
          contentClassName
        ),
        children
      }
    )
  ] }));
};
var Collapsible_default = Collapsible;

// src/Collapsible/CollapsibleText.tsx
import { useLayoutEffect, useRef, useState } from "react";
import { motion } from "motion/react";
import { twMerge as twMerge2 } from "tailwind-merge";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var lineClamps = {
  1: "line-clamp-1",
  2: "line-clamp-2",
  3: "line-clamp-3",
  4: "line-clamp-4",
  5: "line-clamp-5",
  6: "line-clamp-6",
  12: "line-clamp-[12]",
  none: "line-clamp-none"
};
var CollapsibleText = ({
  text,
  minimum = 3,
  className,
  btnProps,
  readMoreLabel = "Read More",
  readLessLabel = "Read Less",
  children
}) => {
  const [showExpandBtn, setShowExpandBtn] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [height, setHeight] = useState("auto");
  const collapsedHeightRef = useRef("auto");
  const ref = useRef(null);
  useLayoutEffect(() => {
    if (!ref.current)
      return;
    const { clientHeight, scrollHeight } = ref.current;
    setShowExpandBtn(scrollHeight > clientHeight);
    setHeight(clientHeight);
    collapsedHeightRef.current = clientHeight;
  }, []);
  const toggle = () => {
    setIsExpanded(!isExpanded);
    requestAnimationFrame(() => {
      if (!ref.current)
        return;
      setHeight(isExpanded ? collapsedHeightRef.current : ref.current.scrollHeight);
    });
  };
  if (!text && !children)
    return null;
  return /* @__PURE__ */ jsxs2("div", { className: "relative inline-block w-full", children: [
    /* @__PURE__ */ jsx2(
      motion.div,
      {
        transition: { duration: 0.25, ease: "easeInOut" },
        className: "overflow-hidden",
        animate: { height },
        style: { height },
        children: /* @__PURE__ */ jsx2(
          "div",
          {
            ref,
            "data-testid": "collapsable-text",
            className: twMerge2(
              "text-text max-w-full overflow-hidden whitespace-pre-wrap",
              !isExpanded && lineClamps[minimum],
              !children && "prose",
              className
            ),
            children: children || /* @__PURE__ */ jsx2("div", { dangerouslySetInnerHTML: { __html: text || "" } })
          }
        )
      }
    ),
    showExpandBtn && /* @__PURE__ */ jsx2(
      Button_default,
      __spreadProps(__spreadValues({
        onClick: toggle,
        shape: "text",
        theme: "transparent",
        className: "text-text-link relative m-px p-0 text-sm ring-0 hover:underline focus:ring-0",
        rounded: true,
        "aria-label": isExpanded ? readLessLabel : readMoreLabel
      }, btnProps), {
        children: isExpanded ? readLessLabel : readMoreLabel
      })
    )
  ] });
};
var CollapsibleText_default = CollapsibleText;

export {
  Collapsible_default,
  CollapsibleText_default
};
//# sourceMappingURL=chunk-VR2USSXN.mjs.map